import { useMutation } from "react-query"
import api from "../client"
import { queryClient, queryKeys } from "../query"
import { OrderBulkFinishPayload, OrderBulkFinishResponseData } from "../types/order"

const postData = async (payload: OrderBulkFinishPayload) => {
    const { data } = await api.post<OrderBulkFinishResponseData>(
        "/orders/bulk/finish",
        payload
    )

    payload.orders.forEach((uuid: string) => {
        queryClient.invalidateQueries(queryKeys.ORDER(uuid))
    })
    queryClient.invalidateQueries(["orders"], { refetchInactive: true })

    return data
}

export const useOrderBulkFinish = () => {
    return useMutation((payload: OrderBulkFinishPayload) => {
        return postData(payload)
    })
}
